<template>
    <div style="padding: 100px 8%;">
        <div class="col-12">
            <h4>編輯特殊條件</h4>
            <form class="form panel panel-form bg-white">
                <div class="row">
                    <div class="col-4">
                        <label class="d-inline-block" for="">
                            特殊條件編號：
                            <span class="text-secondary">{{ formData.code }}</span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="reportName">特殊條件名稱：</label>
                        <input class="form-control form-control-inline w-50" id="reportName" type="text" maxlength="20" v-model="formData.code_name"/>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="">
                            更新日期：
                            <span class="text-secondary">{{ currentDate }}</span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="memo">備註：</label>
                        <input class="form-control form-control-inline w-75" id="memo" type="text" maxlength="20" v-model="formData.memo"/>
                    </div>
                </div>
                <hr class="hr-dashed mg-b-40"> <!--分隔線-->
                <div v-if="isLoading">
                    <Message
                        class="mt-5 mb-4 d-flex justify-content-center"
                        loading
                        message="資料讀取中，請稍候..."
                    />
                </div>
                <div v-else-if="isError" class="container mt-3">
                    <Message
                        class="mt-5 mb-4 d-flex justify-content-center"
                        message="資料載入失敗，請洽相關人員"
                    />
                </div>
                <div v-else class="row">
                    <div class="col-12 mb-3">
                        <SpecialConditionDetailTableForm
                            ref="detailForm"
                            :key="formKey"
                            :details="formData.details"
                            @delete="onDelete"
                        ></SpecialConditionDetailTableForm>
                    </div>
                    <!-- 異動原因 -->
                    <div class="col-12 d-flex text-right mb-3">
                        <label class="flex-shrink-0 mr-2" for="reason">異動原因：</label>
                        <textarea
                            id="reason"
                            v-model="formData.modification_reason"
                            class="form-control"
                            rows="4"
                            maxlength="400"
                        ></textarea>
                    </div>
                    <!-- 按鈕區 -->
                    <div class="col-12 text-right mb-3">
                        <button class="btn btn-default" @click.stop.prevent="$router.go(-1)">取消</button>
                        <button class="btn btn-primary" @click.stop.prevent="onUpdateValidate()">存檔</button>
                        <button class="btn btn-primary" @click.stop.prevent="onCheck()" :disabled="!checkable">覆核生效</button>
                    </div>
                    <!-- 異動列表 -->
                    <div class="col">
                        <record-data-table :data="records"></record-data-table>
                    </div>
                </div>
            </form>
        </div>
        <ConfirmModal
            :open="confirmModalOpen"
            @confirm="onConfirm"
            @close="panelClose('confirmModalOpen')">
            <template slot="title">
                <template v-if="confirmType === 'delete'">確認是否刪除？</template>
                <template v-else-if="confirmType === 'update'">是否確認要儲存？</template>
                <template v-else-if="confirmType === 'check'">是否確認要覆核生效？</template>
            </template>
        </ConfirmModal>
    </div>
</template>
  
<script>
import Message from "@/desktop/components/Message.vue";
import { commonMixin } from "@/mixins/common";
import ConfirmModal from "./components/ConfirmModal.vue";
import RecordDataTable from "./components/RecordDataTable.vue";
import SpecialConditionDetailTableForm from "./components/SpecialConditionDetailTableForm.vue";
import { 
    getSpecialConditionDetailForEdit, 
    getSpecialConditionChangeRecords, 
    updateSpecialCondition, 
    saveSpecialCondition, 
} from "@/service";

export default {
    name: "SpecialConditionDetailEdit",
    mixins: [commonMixin],
    components: { 
        Message,
        ConfirmModal,
        RecordDataTable,
        SpecialConditionDetailTableForm,
    },
    data() {
        return {
            isLoading: false,
            isError: false,
            currentDate: "",
            records: [],
            formKey: 0,
            formData: {
                code: "",
                code_name: "",
                details: [],
                modification_reason: "",
                memo: "",
                status: "0",
                creator: "",
                creatorname: "",
            },
            deleteData: [],
            // 確認彈窗開關
            confirmModalOpen: false, 
            // 確認彈窗類型 (delete:刪除, update:存檔, check:覆核生效)
            confirmType: "", 
            checkable: false
        };
    },
    methods: {
        init() {
            this.currentDate = this.getCurrentDate();
            this.userID = this.$store.state.userInfo.id;
            this.formData.creator = this.$store.state.userInfo.id;
            this.formData.creatorname = this.$store.state.userInfo.name;
            this.formData.code = this.$route.params.code;
            this.formData.modification_reason = "";
            this.previousActions = [];
        },
        /** 按下存檔按鈕的事件與檢核 */
        onUpdateValidate() {
            if (this.$refs["detailForm"].validate()) {
                if (!this.formData.modification_reason) {
                    this.$toast.info({ title: "請輸入異動原因" });
                    return;
                }
                // 確認存檔彈窗
                this.confirmType = "update";
                this.panelOpen('confirmModalOpen');
            }
            
        },
        /** 按下覆核生效按鈕的事件 */
        onCheck() {
            // 確認覆核生效彈窗
            this.confirmType = "check";
            this.panelOpen('confirmModalOpen');
        },
        onDelete(data) {
            // 確認刪除彈窗
            this.confirmType = "delete";
            this.deleteData = data;
            this.panelOpen("confirmModalOpen");
            console.log("onDelete", data);
        },
        onConfirm() {
            switch (this.confirmType) {
                case "delete": this.doDelete(); break;
                case "update": this.doUpdate(); break;
                case "check": this.doSave(); break;
                default: break;
            }
            this.panelClose("confirmModalOpen")
        },
        doDelete() {
            for (let i = 0; i < this.deleteData.length; i++) {
                this.formData.details.splice(this.deleteData[i] - i, 1);
            }
            this.formKey++;
        },
        /** 存檔 */
        async doUpdate() {
            console.log("details", this.formData.details)
            await updateSpecialCondition(this.userID, this.formData).then((result) => {
                if (result.header && result.header.status == "200") {
                    this.$toast.info({ title: "更新特殊條件成功" });
                    this.getChangeRecords();
                    this.checkable = false; // 存檔後此人員就不能覆核生效
                } else {
                    this.$toast.info({ title: result.header.message });
                }
            });
        },
        /** 覆核生效 */
        async doSave() {
            await saveSpecialCondition(this.userID, this.formData.code).then((result) => {
                if (result.header && result.header.status == "200") {
                    this.$toast.info({ title: "特殊條件覆核生效成功" });
                    this.checkable = false;
                } else {
                    this.$toast.info({ title: result.header.message });
                }
            });
        },
        /** 查詢保障內容設定 */
        async getSpecialConditionData() {
            this.init();
            this.isLoading = true; 
            getSpecialConditionDetailForEdit(
                this.$store.state.userInfo.id, 
                this.formData.code
            ).then(result => {
                if (result.header.status == "200" && result.body) {
                    this.records = result.body.records;
                    this.checkable = result.body.checkable;

                    this.formData.code_name = result.body.code_name;
                    this.formData.memo = result.body.memo;
                    this.formData.details = result.body.details;
                } else {
                    this.isError = true;
                }
                this.isLoading = false;
            });
        },
        /** 查詢異動紀錄 */
        async getChangeRecords() {
            getSpecialConditionChangeRecords(
                this.$store.state.userInfo.id, 
                this.formData.code
            ).then(result => {
                if (result.header.status == "200" && result.body) {
                    this.records = result.body;
                    this.formData.modification_reason = "";
                }
            });
        },
    },
    created() {
        this.getSpecialConditionData();
    },
};
</script>

<style lang="scss" scoped>
.hr-dashed {
  border: 0;
  border-top: 2px dashed #a2a9b6;
}
</style>